/**
 * WCML currency switcher — keyboard: Tab opens list (not mouse), Tab through options, blur/Escape closes.
 * Avoids fighting WCML click-toggle: we only auto-open when focus came from keyboard (Tab).
 *
 * Mouse hover uses WCML stylesheet rules on .wcml-cs-submenu. Do not set inline visibility on
 * the submenu (except legacy cleanup): inline beats :hover and breaks the dropdown after Escape
 * or after our closeSubmenu ran once.
 */
const WCML_KEYBOARD_OPEN_CLASS = 'wcml-cs-keyboard-open';

export function initWcmlCurrencyA11y() {
  let lastInputWasKeyboard = false;

  const run = () => {
    document.addEventListener('pointerdown', () => {
      lastInputWasKeyboard = false;
    }, true);

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Tab') {
        lastInputWasKeyboard = true;
      }
    }, true);

    document.querySelectorAll('.wcml_currency_switcher').forEach((wrapper) => {
      const toggle = wrapper.querySelector('a.wcml-cs-item-toggle');
      const submenu = wrapper.querySelector('.wcml-cs-submenu');
      if (!toggle || !submenu) {
        return;
      }

      if (!toggle.getAttribute('href')) {
        toggle.setAttribute('href', '#');
      }
      toggle.setAttribute('aria-haspopup', 'true');
      toggle.setAttribute('aria-expanded', 'false');

      submenu.querySelectorAll('a[rel]').forEach((link) => {
        if (!link.getAttribute('href')) {
          link.setAttribute('href', '#');
        }
      });

      const isOpen = () => wrapper.classList.contains(WCML_KEYBOARD_OPEN_CLASS);

      const syncExpanded = () => {
        toggle.setAttribute('aria-expanded', isOpen() ? 'true' : 'false');
      };

      const openSubmenu = () => {
        wrapper.classList.add(WCML_KEYBOARD_OPEN_CLASS);
        syncExpanded();
      };

      const closeSubmenu = () => {
        wrapper.classList.remove(WCML_KEYBOARD_OPEN_CLASS);
        syncExpanded();
      };

      toggle.addEventListener('focusin', () => {
        if (lastInputWasKeyboard) {
          openSubmenu();
        }
      });

      wrapper.addEventListener('focusout', () => {
        setTimeout(() => {
          if (!wrapper.contains(document.activeElement)) {
            closeSubmenu();
          }
        }, 0);
      });

      wrapper.addEventListener('click', () => {
        requestAnimationFrame(syncExpanded);
      });

      toggle.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowDown' && submenu.querySelector('a[rel]')) {
          e.preventDefault();
          if (!isOpen()) {
            openSubmenu();
          }
          submenu.querySelector('a[rel]').focus();
          return;
        }

        if (e.key !== 'Enter' && e.key !== ' ') {
          return;
        }
        e.preventDefault();

        if (isOpen()) {
          const first = submenu.querySelector('a[rel]');
          if (first) {
            first.focus();
          }
          return;
        }
        openSubmenu();
      });
    });

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') {
        return;
      }
      document.querySelectorAll('.wcml_currency_switcher').forEach((w) => {
        w.classList.remove(WCML_KEYBOARD_OPEN_CLASS);
      });
      document.querySelectorAll('.wcml_currency_switcher a.wcml-cs-item-toggle').forEach((btn) => {
        btn.setAttribute('aria-expanded', 'false');
      });
    });
  };

  setTimeout(run, 0);
}
